import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import GetDesignFolderDetails from "./DesignPrintGetDesignFolderDetails";


const DesignPrint = () => {

    const { id } = useParams();
    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => { if (!result) { localStorage.clear(); setUser({}); navigate("/Login") } });

    //pr_CNF_GetDesignDetails
    let response26 = useInvoke("WebApps", "26", { "@DesignId": id });

    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [configuration, setConfiguration] = useState([]);
    const [designFolderID, setDesignFolderID] = useState("");
    const [designFolderDetails, setDesignFolderDetails] = useState([]);

    useEffect(() => {

        if (response26.data.payload != undefined) {
            let data = JSON.parse(response26.data.payload).data[0];

            let rowsList = [];

            data["DesignNum"] = data[0];
            data["CompletedDate"] = data[1];
            data["InducedAirFlow"] = data[2];
            data["InjectedAirFlow"] = data[3];
            data["Total Discharge Air Flow"] = data[4];
            data["NegativeStaticPressure"] = data[5];
            data["BestNegativeStaticPressure"] = data[6];
            data["TotalStaticPressure"] = data[7];
            data["BestStaticPressure"] = data[8];
            data["SystemBalance"] = data[9];

            if (data[10]) {
                data["Notes"] = data[10];
            }

            data["Components"] = [];

            if (data[11]) {
                let components = data[11].split("|");
                let lastValidCFM = null;

                components.forEach((c, index) => {
                    c = c.split("‡");
                    let obj = {};

                    obj["key"] = index;
                    obj["id"] = c[0];

                    //Append and pad out the ID with 'DP' and 0's 
                    let num = c[1].toString(); while (num.length < 2) num = `0${num}`;

                    obj["Item"] = num;

                    obj["Type"] = c[2];
                    obj["Category"] = c[3];
                    obj["Component"] = c[4].replace("&amp;", "&");
                    obj["Diameter"] = c[5];
                    obj["Length"] = c[6];
                    obj["Velocity"] = c[7];
                    obj["PressureLoss"] = c[8];
                    obj["CFM"] = c[9];
                    obj["Note"] = c[10].replace("&amp;", "&");
                    obj["prevCFM"] = lastValidCFM; //Will contain CFM of component above the current one

                    if (obj["CFM"]) { lastValidCFM = obj["CFM"]; }

                    let row = {
                        key: index,
                        data: [
                            { td: c[1], key: 0 },
                            { td: c[2], key: 1 },
                            { td: c[3], key: 2 },
                            { td: c[4].replace("&amp;", "&"), key: 3 },
                            { td: c[5], key: 4 },
                            { td: c[6], key: 5 },
                            { td: c[7], key: 6 },
                            { td: c[8], key: 7 },
                            { td: obj["CFM"].trim() !== "" ? obj["CFM"] : lastValidCFM, key: 8 },
                            //{td: c[10].replace("&amp;", "&"), key: 9}
                        ],
                        note: c[10].replace("&amp;", "&")
                    };

                    rowsList.push(row);

                    data["Components"].push(obj);
                });

            }

            let num = data["12"].toString(); while (num.length < 6) num = "0" + num;
            let sequence = data["DesignNum"];
            while (sequence.length < 2) sequence = "0" + sequence;
            data["DesignFolderNum"] = `DES#${num}-${sequence}`;
            setDesignFolderID(data["13"]);
            data.splice(0, 13)
            setConfiguration(data);

            setColumns([
                { col: "Item", key: 0 },
                { col: "Type", key: 1 },
                { col: "Category", key: 2 },
                { col: "Component", key: 3 },
                { col: "Diameter (in)", key: 4 },
                { col: "Length (ft)", key: 5 },
                { col: "Velocity (fpm)", key: 6 },
                { col: "Pressure Loss (in H2O)", key: 7 },
                { col: "CFM", key: 8 },
                //{col: "Note", key: 9}
            ]);

            setRows(rowsList);
        }

    }, [response26.isPending]);

    useEffect(() => {
        if (designFolderID != "") {
            GetDesignFolderDetails(designFolderID)
                .then((response) => {
                    response ? setDesignFolderDetails(JSON.parse(response.payload).data[0]) : toast.error("An error has occurred.");
                });
        }

    }, [configuration]);

    const handlePrint = () => {
        window.print();
    };

    document.title = `Design - Print`;
    return (
        <>

            {designFolderDetails &&
                <div className="body-content" style={{ marginTop: "25px", width: "1100px", margin: "auto" }}>
                    <div className="no-print" style={{ marginBottom: "8px" }}>
                        <Link to={`/Design/Edit/${id}`} className="btn btn-default" style={{ width: "132px" }}>Back</Link>
                        <button onClick={handlePrint} className="btn btn-primary" style={{ width: "132px", marginLeft: "8px" }}>Print This Page</button>
                    </div>

                    <div style={{ widtH: "100%" }}>
                        <h3>System Design Sheet</h3>
                    </div>

                    <table width="100%">
                        <tbody>

                            <tr>
                                <td rowSpan="2" style={{ width: "30%" }}>
                                    <img src="data:image/png;base64,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" height="30px;" style={{ paddingRight: "25px" }} />
                                </td>

                                {/* <td style={{width: "70%", textAlign: "right", fontWeight: "bold"}}>Sales Application Design for DES#001156-01 (Compass Ref #0)</td> */}
                                <td style={{ width: "70%", textAlign: "right", fontWeight: "bold" }}>Sales Application Design for {configuration["DesignFolderNum"]}</td>

                            </tr>

                            <tr>
                                <td style={{ textAlign: "right" }}>
                                    Created {designFolderDetails[1]} by {designFolderDetails[2]}
                                    &nbsp;&nbsp;&nbsp;
                                    {configuration["CompletedDate"] == null &&
                                        <>Status: In Process</>
                                    }

                                    {configuration["CompletedDate"] != null &&
                                        <>Status: <b>Finalized</b></>
                                    }
                                </td>
                            </tr>

                        </tbody>

                    </table>

                    <hr style={{ color: "black", padding: "0px", border: "2px solid black", marginTop: "5px", marginBottom: "10px", background: "transparent", display: "block", width: "100%" }} />

                    <table width="100%">

                        <tbody>

                            <tr>
                                <td style={{ width: "33%", fontWeight: "bold" }}>Customer</td>
                                <td style={{ width: "33%", fontWeight: "bold" }}>Site Location</td>
                                <td rowSpan="2" style={{ width: "33%", verticalAlign: "top" }}><b>Industry:</b> {designFolderDetails[15]}</td>
                            </tr>

                            <tr>
                                <td style={{ fontWeight: "bold" }}>{designFolderDetails[5]}</td>
                                <td style={{ fontWeight: "bold" }}>{designFolderDetails[8]}</td>
                            </tr>

                            <tr>
                                <td>{designFolderDetails[6]}</td>
                                <td>{designFolderDetails[9]}</td>
                                <td rowSpan="2" style={{ verticalAlign: "top" }}><b>Materials Handled:</b> {designFolderDetails[16]}</td>
                            </tr>

                            <tr>
                                <td>{designFolderDetails[7]}</td>
                                <td>{designFolderDetails[10]}</td>
                            </tr>

                            <tr>
                                <td><b>Customer Ref#:</b> {designFolderDetails[4]}</td>
                                <td><b>Elevation:</b> {designFolderDetails[11]} ft</td>
                                <td>{designFolderDetails[17]}</td>
                            </tr>

                        </tbody>

                    </table>

                    <div style={{ border: "1px solid black", marginTop: "10px", marginBottom: "10px", height: "auto", minHeight: "100px" }}>
                        <span style={{ marginLeft: "5px", marginRight: "5px" }}>
                            <b>Project Notes</b>
                            <br />
                            <span style={{ minHeight: "50px", maxHeight: "150px", marginLeft: "5px", marginRight: "5px" }}>{designFolderDetails[18]}</span>
                        </span>
                    </div>

                    <table width="100%" className="table">
                        <thead>
                            <tr>
                                {columns.map((c, index) => (
                                    <th key={index} style={{ border: "2px solid black" }}>
                                        <div>{c["col"]}</div>
                                    </th>
                                ))
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((tr, rowIndex) => (
                                <React.Fragment key={rowIndex}>
                                    <tr style={{ borderLeft: "2px solid black", borderRight: "2px solid black" }}>
                                        {tr["data"].map((td, dataIndex) => (
                                            <td key={dataIndex} style={{ borderTop: "2px solid lightgray" }}>{td["td"]}</td>
                                        ))}
                                    </tr>

                                    {tr["note"] && (
                                        <tr style={{ borderLeft: "2px solid black", borderRight: "2px solid black", borderBottom: "2px solid black", textAlign: "left" }}>
                                            <td colSpan={tr["data"].length}><b>Note: </b><i>{tr["note"]}</i></td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}
                        </tbody>

                    </table>

                    <div className="no-break">

                        <table width="100%" className="table">

                            <tbody>

                                <tr style={{ borderLeft: "2px solid black", borderRight: "2px solid black", borderTop: "2px solid black" }}>
                                    <th colSpan="4" style={{ textAlign: "right", paddingRight: "50px", borderRight: "2px solid black" }}>Induced Air Flow:</th>
                                    <th colSpan="5" style={{ borderTop: "1px solid gray", borderBottom: "1px solid gray" }}>{parseFloat(configuration["InducedAirFlow"]).toFixed(0)}</th>
                                </tr>

                                <tr style={{ borderLeft: "2px solid black", borderRight: "2px solid black" }}>
                                    <th colSpan="4" style={{ textAlign: "right", paddingRight: "50px", borderRight: "2px solid black" }}>Injected Air Flow:</th>
                                    <th colSpan="5" style={{ borderTop: "1px solid gray", borderBottom: "1px solid gray" }}>{parseFloat(configuration["InjectedAirFlow"]).toFixed(0)}</th>
                                </tr>

                                <tr style={{ borderLeft: "2px solid black", borderRight: "2px solid black" }}>
                                    <th colSpan="4" style={{ textAlign: "right", paddingRight: "50px", borderRight: "2px solid black" }}>Total Discharge Air Flow:</th>
                                    <th colSpan="5" style={{ borderTop: "1px solid gray", borderBottom: "1px solid gray" }}>{parseFloat(configuration["Total Discharge Air Flow"]).toFixed(0)}</th>
                                </tr>

                                <tr style={{ borderLeft: "2px solid black", borderRight: "2px solid black" }}>
                                    <th colSpan="4" style={{ textAlign: "right", paddingRight: "50px", borderRight: "2px solid black" }}>System Negative Static Pressure:</th>
                                    <th colSpan="3" style={{ borderTop: "1px solid gray", borderBottom: "1px solid gray" }}>{parseFloat(configuration["NegativeStaticPressure"]).toFixed(3)}&nbsp;(longest run)</th>
                                    <th colSpan="2" style={{ borderTop: "1px solid gray", borderBottom: "1px solid gray" }}>{parseFloat(configuration["BestNegativeStaticPressure"]).toFixed(3)}&nbsp;(shortest run)</th>
                                </tr>

                                <tr style={{ borderLeft: "2px solid black", borderRight: "2px solid black" }}>
                                    <th colSpan="4" style={{ textAlign: "right", paddingRight: "50px", borderRight: "2px solid black" }}>System Total Static Pressure:</th>
                                    <th colSpan="3" style={{ borderTop: "1px solid gray", borderBottom: "1px solid gray" }}>{parseFloat(configuration["TotalStaticPressure"]).toFixed(3)}&nbsp;(longest run)</th>
                                    <th colSpan="2" style={{ borderTop: "1px solid gray", borderBottom: "1px solid gray" }}>{parseFloat(configuration["BestStaticPressure"]).toFixed(3)}&nbsp;(shortest run)</th>
                                </tr>

                                <tr style={{ borderLeft: "2px solid black", borderRight: "2px solid black", borderBottom: "2px solid black" }}>
                                    <th colSpan="4" style={{ textAlign: "right", paddingRight: "50px", borderRight: "2px solid black" }}>System Balance:</th>
                                    <th colSpan="5" style={{ borderTop: "1px solid gray", borderBottom: "1px solid gray" }}>{parseFloat(configuration["SystemBalance"]).toFixed(3)}%</th>
                                </tr>

                            </tbody>
                        </table>

                        <div style={{ border: "1px solid black", marginTop: "10px", marginBottom: "10px", height: "auto", minHeight: "100px" }}>
                            <span style={{ marginLeft: "5px", marginRight: "5px" }}>
                                <b>Design Notes</b>
                                <br />
                                <span style={{ minHeight: "50px", maxHeight: "150px", marginLeft: "5px", marginRight: "5px" }}>
                                    {configuration["Notes"]}
                                </span>
                            </span>
                        </div>

                        <div style={{ width: "100%", textAlign: "center" }}>Confidential – for Compass internal use only</div>

                    </div>

                </div>
            }
        </>
    );
}

export default DesignPrint;